import { render, staticRenderFns } from "./m-announcement-bar.vue?vue&type=template&id=5bb84f40&scoped=true&"
import script from "./m-announcement-bar.vue?vue&type=script&lang=js&"
export * from "./m-announcement-bar.vue?vue&type=script&lang=js&"
import style0 from "./m-announcement-bar.vue?vue&type=style&index=0&id=5bb84f40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb84f40",
  null
  
)

export default component.exports